import { useMutation } from '@tanstack/react-query';

import axios from 'axios';
import { MutationConfig, queryClient } from 'lib/react-query';

export const deleteWeatherWall = (wallId: number) => {
  return axios.delete(`/api/weather/walls/${wallId}`);
};

type UseDeleteWeatherWallOptions = {
  config?: MutationConfig<typeof deleteWeatherWall>;
};

export const useDeleteWeatherWall = ({
  config,
}: UseDeleteWeatherWallOptions) => {
  return useMutation({
    onError: (_, __, context: any) => {
      if (context?.previousWeatherWalls) {
        queryClient.setQueryData(
          ['weatherWalls'],
          context.previousWeatherWalls
        );
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['weatherWalls']);
      queryClient.invalidateQueries(['weatherFolders']);
    },
    ...config,
    mutationFn: deleteWeatherWall,
  });
};
